import PageBase from "./PageBase";
import React from "react";
import { authRequest } from "../../api/auth.js";
import { host } from "../../config.js";
import {variant_table} from "../../settings.js";
import {Oval} from '@agney/react-loading'
import {Nav, Table, Container, Row, Col, Form, Button, ButtonGroup} from 'react-bootstrap';
import {Link} from "react-router-dom";
//import { Container, Row, Col, Button, ButtonGroup, Table } from 'react-bootstrap';

export default class Filter extends PageBase {
    state = {
        companies_loading: true,
        companies: [],
        companies_filtered: [],
        _companies: [],
        weekly_prices: [],
        open_dates: [],
        open_date: '',
        count : 0
    }

    setCompanies(queryParams){
        //authRequest.get("http://"+host+":8000/api/companies",{ params: {}}) //WithAuth
        //authRequest.get("http://"+host+":8000/api/weekly_filters",{ params: {'open_date':'2022-03-28'}}) // open_date
        //authRequest.get("http://"+host+":8000/api/weekly_filters",{ params: {'code':'1332'}}) // code
        authRequest.get("http://"+host+":8000/api/weekly_filters_open_date/",{ params: {}})
            .then(res => {
                const open_dates = res.data.results;
                this.setState({ open_dates });
                let open_date = queryParams.get("open_date");
                if (open_date == null){
                    let offset = queryParams.get("offset");
                    if (offset == null){
                        offset = 1
                    }
                    open_date = open_dates[open_dates.length -1 * offset ]
                }
                this.setState({open_date});
                console.log('(1/4) this.state.open_date.length: ', this.state.open_date.length);
                authRequest.get("http://"+host+":8000/api/companies",{ params: {}}) //WithAuth
                    .then(res => {
                        const companies = res.data.results;
                        // const count = res.data.count;
                        var _companies = [];
                        companies.forEach(c => {_companies[c.code] = c});
                        this.setState({ _companies });
                        console.log('(2/4) _companies.length: ', _companies.length);
                        authRequest.get("http://"+host+":8000/api/weekly_prices",{ params: {'open_date':this.state.open_date}}) // open_date
                            .then(res => {
                                const _weekly_prices = res.data.results;
                                var weekly_prices = [];
                                _weekly_prices.forEach(function callback(wp, k) {
                                    weekly_prices[wp.code] = wp;
                                });
                                this.setState({ weekly_prices });
                                console.log('(3/4) this.state.weekly_prices.length: ', this.state.weekly_prices.length);
                                authRequest.get("http://"+host+":8000/api/weekly_filters",{ params: {'open_date':this.state.open_date}}) // open_date
                                    .then(res => {
                                        const companies = res.data.results;
                                        const count = res.data.count;
                                        var _companies = this.state._companies;
                                        companies.forEach(function callback(c, k) {
                                            companies[k].name = _companies[companies[k].code].name;
                                            companies[k].name_ja = _companies[companies[k].code].name_ja;
                                            companies[k].market = _companies[companies[k].code].market;
                                            companies[k].industry = _companies[companies[k].code].industry;
                                            companies[k].industry_ja = _companies[companies[k].code].industry_ja;
                                            companies[k].description = _companies[companies[k].code].description;
                                            companies[k].description_ja = _companies[companies[k].code].description_ja;
                                            if(weekly_prices[companies[k].code] != null){
                                                companies[k].a_m_buy = weekly_prices[companies[k].code].a_m_buy;
                                            }
                                        })
                                        this.setState({ companies });
                                        this.setState({ count });
                                        this.setState({ companies_loading: false });
                                        this.setState({ companies_filtered: companies });
                                         console.log('(4/4) this.state.companies.length: ', this.state.companies.length);
                                    }
                                )
                            }
                        )
                    }
                )
            }
        )
    }
    componentDidMount() {
        let queryParams = new URLSearchParams(window.location.search);
        this.setCompanies(queryParams);
    }

    filterList = (e) => {
        const filtered = this.state.companies.filter((company_filtered) => {
            return company_filtered.code.toLowerCase().search( e.target.value.toLowerCase()) !== -1
            || (company_filtered.name_ja !== null && company_filtered.name_ja.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
        //  || (company_filtered.name_ja_ruby !== null && company_filtered.name_ja_ruby.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.industry_ja !== null && company_filtered.industry_ja.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
        //  || (company_filtered.fund_family_ja !== null && company_filtered.fund_family_ja.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.description_ja !== null && company_filtered.description_ja.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.name !== null && company_filtered.name.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.industry !== null && company_filtered.industry.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
        //  || (company_filtered.fund_family !== null && company_filtered.fund_family.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.description !== null && company_filtered.description.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            ;
        })
        this.setState({companies_filtered: filtered})
    }

    render() {
        let date = new Date();
        date.setFullYear(date.getFullYear()-1)
        //let date_from = date.toISOString().substring(0, 10)
        //let companies = this.state.companies_filtered;
        let companies = this.state.companies_filtered.filter((c) =>{return (
            c.next_a_close_ma_3m_pct < -4.5 // 株価が3ヶ月移動平均より4.5%低いかそれ以下 // c.close_adj_next_ma_3m_pct < -4.5
            && c.a_m_buy_ma_3m_pct > 12 // 信用買い残が3ヶ月移動平均の12%高いかそれ以上  // && c.m_buy_adj_ma_3m_pct > 12
            && c.a_m_sell_ma_3m_pct < -25 // 信用売り残が3ヶ月移動平均の25%低いかそれ以下 // && c.m_sell_adj_ma_3m_pct < -25
            && c.dc_ratio_ma_3m_pct > 60 // 騰落レシオが3ヶ月移動平均の60%高いかそれ以上 // && c.dc_ratio_ma_3m_pct > 60 // 70
            && c.dc_ratio_up_count >= 4 // 騰落レシオが連続で4回以上上昇 // && c.dc_ratio_up_count >= 4
            && c.a_m_buy > 100000 // 信用買い残が100,000以上 // && c.m_buy_adj > 100000
        );} )
        const style_loading = {"height":"100vh"};
        const style = {
            "font-family": "Meiryo,Hiragino Sans,Hiragino Kaku Gothic ProN,Meiryo,sans-serif,Emoji;",
            "height":"100%"
        };
        //const style = {hight: 100%};
        if (this.state.companies_loading){
            let r = (
            <Container style={style_loading}>
                <Row class="mt-5"><Col class="col-md-12">&nbsp;</Col></Row>
                <Row>
                    <Col class="col-md-4"></Col>
                    <Col class="col-md-4"><Oval width="250" color="#3db70f"/></Col>
                    <Col class="col-md-4"></Col>
                </Row>
                <Row class="mt-5"><Col class="col-md-12">&nbsp;</Col></Row>
            </Container>);
            return this.redirectLogin('/login', r);
        }else{
            // <td><Nav.Link as={Link} to={`/weekly_price/?code=${r.code}&date_from=${date_from}`}>{r.code}</Nav.Link></td>
            let open_dates = this.state.open_dates;
            let r = (
                <Container style={style} class="pt-3">
                <Row class = "center-block">
                    <div class="col-md-12 bg-secondary text-center">
                        <h2 class="text-light">フィルタ</h2>
                        <ButtonGroup>
                            <Button variant="secondary" href='/filter?offset=7' target="_blank"> {open_dates[open_dates.length-7]} </Button>
                            <Button variant="secondary" href='/filter?offset=6' target="_blank"> {open_dates[open_dates.length-6]} </Button>
                            <Button variant="secondary" href='/filter?offset=5' target="_blank"> {open_dates[open_dates.length-5]} </Button>
                            <Button variant="secondary" href='/filter?offset=4' target="_blank"> {open_dates[open_dates.length-4]} </Button>
                            <Button variant="secondary" href='/filter?offset=3' target="_blank"> {open_dates[open_dates.length-3]} </Button>
                            <Button variant="secondary" href='/filter?offset=2' target="_blank"> {open_dates[open_dates.length-2]} </Button>
                            <Button variant="secondary" href='/filter?offset=1' target="_blank"> {open_dates[open_dates.length-1]} </Button>
                        </ButtonGroup>
                    </div>
                    <div class="text-center center-block pt-3" style={{ margin: "0 auto" }}>
                        <Form action="">
                            <div class="col-md-4 "> <Form.Control class="form-control col-md-4" placeholder="Search" onChange={this.filterList}/></div>
                            <div class="col-md-4"> {companies.length} result(s)</div>
                        </Form>
                    </div>
                </Row>
                <div> {this.state.open_date}</div>
                    <Table striped bordered hover variant={variant_table}>
                        <thead>
                            <tr>
                                <th scope="col">Code</th>
                                <th scope="col">Name(JA)</th>
                                <th scope="col">Market</th>
                                <th scope="col">Industry(JA)</th>
                                <th scope="col">Description(JA)</th>
                                <th scope="col">Links</th>
                            </tr>
                        </thead>
                        <tbody>
                            {companies.map(r =>
                                <tr class="table-sm">
                                    <td><Nav.Link as={Link} to={`/weekly_price/?code=${r.code}`} target="_blank">{r.code}</Nav.Link></td>
                                    <td class="text-left" >{r.name_ja}</td>
                                    <td class="text-left">{r.market}</td>
                                    <td class="text-left">{r.industry_ja}</td>
                                    <td class="text-left"> {r.description_ja}</td>
                                    <td class="text-left"><a className="custom-style" href={`https://finance.yahoo.co.jp/quote/${r.code}`} rel="noopener noreferrer" target="_blank">Y!JP</a></td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Container>
            );
            return this.redirectLogin('/login', r);
        }
    }
}
